import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "tooltip"
};
const _hoisted_2 = {
  key: 0,
  class: "outline-content"
};
const _hoisted_3 = {
  key: 1,
  class: "outline-content"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "video-length"
};
const _hoisted_6 = {
  class: "text-area"
};
const _hoisted_7 = {
  class: "top-title-container hidden-720"
};
const _hoisted_8 = {
  class: "feature-info rl-uppercase"
};
const _hoisted_9 = {
  style: {
    "margin-right": "calc(0.1vw + 6px)"
  }
};
const _hoisted_10 = {
  style: {
    "display": "inline-block"
  }
};
const _hoisted_11 = {
  key: 0,
  class: "feature-info loading-animation"
};
const _hoisted_12 = {
  key: 0,
  "xlink:href": "#bookmark_1_"
};
const _hoisted_13 = {
  key: 1,
  "xlink:href": "#bookmark-active"
};
const _hoisted_14 = {
  class: "delete"
};
const _hoisted_15 = {
  class: "bottom-title-container"
};
const _hoisted_16 = {
  class: "hidden-720 ellipsis"
};
const _hoisted_17 = {
  key: 0
};
const _hoisted_18 = {
  key: 0,
  class: "product-version no-version",
  style: {
    "visibility": "hidden"
  }
};
const _hoisted_19 = {
  style: {
    "display": "flex",
    "justify-content": "space-between"
  }
};
const _hoisted_20 = {
  key: 1,
  class: "label"
};
const _hoisted_21 = {
  class: "visible-720"
};
const _hoisted_22 = {
  key: 0,
  "xlink:href": "#bookmark_1_"
};
const _hoisted_23 = {
  key: 1,
  "xlink:href": "#bookmark-active"
};
const _hoisted_24 = {
  class: "delete"
};
const _hoisted_25 = {
  class: "group-description body-2 rl-fontweight-medium"
};
const _hoisted_26 = ["innerHTML"];
const _hoisted_27 = {
  key: 1,
  class: "product-version",
  style: {
    "font-weight": "400"
  }
};
const _hoisted_28 = {
  key: 2,
  class: "hidden-720 speaker"
};
const _hoisted_29 = {
  class: "author-container"
};
const _hoisted_30 = {
  key: 0
};
const _hoisted_31 = ["title"];
const _hoisted_32 = {
  key: 3,
  class: "rl-row-bottom-10"
};
const _hoisted_33 = {
  class: "visible-720"
};
const _hoisted_34 = {
  class: "ellipsis rl-row-bottom-10"
};
const _hoisted_35 = {
  key: 0
};
const _hoisted_36 = {
  class: "feature-info rl-uppercase"
};
const _hoisted_37 = {
  style: {
    "margin-right": "calc(0.1vw + 6px)"
  }
};
const _hoisted_38 = {
  style: {
    "display": "inline-block"
  }
};
const _hoisted_39 = {
  key: 0,
  class: "feature-info loading-animation"
};
const _hoisted_40 = {
  key: 1
};
const _hoisted_41 = {
  class: "skeleton-img"
};
const _hoisted_42 = ["src"];
const _hoisted_43 = {
  style: {
    "padding": "14px"
  }
};
const _hoisted_44 = {
  class: "rl-row-10"
};
const _hoisted_45 = {
  class: "rl-row-bottom-10"
};
const _hoisted_46 = {
  key: 2,
  class: "details-mode"
};
const _hoisted_47 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_48 = {
  class: "img-container skeleton-img"
};
const _hoisted_49 = ["src"];
const _hoisted_50 = {
  style: {
    "padding": "0.625vw",
    "flex-grow": "1"
  }
};
const _hoisted_51 = {
  style: {
    "padding": "calc(1vw + 0.4px) 0"
  }
};
const _hoisted_52 = {
  style: {
    "padding-bottom": "calc(1vw + 0.4px)"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_tooltip = _resolveComponent("el-tooltip");
  const _component_router_link = _resolveComponent("router-link");
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item");
  const _component_el_skeleton = _resolveComponent("el-skeleton");
  const _directive_intersectionObserver = _resolveDirective("intersectionObserver");
  return _openBlock(), _createElementBlock(_Fragment, null, [!$props.groupInfo.isSkeleton ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: "outline-list",
    style: _normalizeStyle([{
      visibility: $setup.state.isShowOutline && $setup.state.timecode.length > 0 ? 'visible' : 'hidden'
    }]),
    ref: "outlineList"
  }, [_cache[9] || (_cache[9] = _createElementVNode("ul", {
    class: "outline-title"
  }, [_createElementVNode("li", null, "OUTLINE")], -1)), !$setup.state.isShowOutline ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.timecode, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      key: index
    }, _toDisplayString(item.text), 1);
  }), 128))])) : _createCommentVNode("", true), $setup.state.isShowOutline ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.displayTimecode, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      key: index
    }, _toDisplayString(item.text), 1);
  }), 128))])) : _createCommentVNode("", true)], 4), _createVNode(_component_router_link, {
    to: $setup.state.detailLink,
    class: "no-underline"
  }, {
    default: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["video-card", {
        'details-mode': $props.viewMode === $setup.state.viewModeType.DETAILS
      }]),
      onClick: _cache[8] || (_cache[8] = $event => $props.clickCardHandler($props.groupInfo, $props.position))
    }, [_createElementVNode("div", {
      class: "img-container",
      onMouseenter: _cache[0] || (_cache[0] = (...args) => $setup.showOutline && $setup.showOutline(...args)),
      onMouseleave: _cache[1] || (_cache[1] = (...args) => $setup.hideOutline && $setup.hideOutline(...args))
    }, [_createElementVNode("img", {
      src: $props.groupInfo.thumbnail
    }, null, 8, _hoisted_4), _createElementVNode("div", _hoisted_5, _toDisplayString($setup.formatSeconds($props.groupInfo.videoLength)), 1)], 32), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("span", null, _toDisplayString($setup.state.category), 1), _cache[10] || (_cache[10] = _createElementVNode("span", {
      style: {
        "padding": "0 calc(0.6vw + 3px)"
      }
    }, "|", -1)), _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("COMMON.LEVEL")), 1), _createElementVNode("span", _hoisted_10, [_createElementVNode("span", {
      class: _normalizeClass(["level-indicator", [$props.groupInfo.level >= 1 ? 'active' : '']])
    }, null, 2), _createElementVNode("span", {
      class: _normalizeClass(["level-indicator", [$props.groupInfo.level >= 2 ? 'active' : '']])
    }, null, 2), _createElementVNode("span", {
      class: _normalizeClass(["level-indicator", [$props.groupInfo.level === 3 ? 'active' : '']])
    }, null, 2)])]), $props.groupInfo.isSkeleton ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString($setup.state.category), 1)) : _createCommentVNode("", true), !$props.isShowDeleteHistoryButton ? (_openBlock(), _createElementBlock("svg", {
      key: 1,
      viewBox: "5 0 22 32",
      class: _normalizeClass(["bookmark", {
        active: $setup.state.isBookmarked
      }]),
      onClick: _cache[2] || (_cache[2] = _withModifiers($event => $props.clickBookmarkHandler(!$setup.state.isBookmarked, $props.groupInfo), ["prevent"]))
    }, [!$setup.state.isBookmarked ? (_openBlock(), _createElementBlock("use", _hoisted_12)) : _createCommentVNode("", true), $setup.state.isBookmarked ? (_openBlock(), _createElementBlock("use", _hoisted_13)) : _createCommentVNode("", true)], 2)) : (_openBlock(), _createBlock(_component_el_tooltip, {
      key: 2,
      content: _ctx.$t('HISTORY.REMOVE_FROM_WATCH_HISTORY'),
      placement: "bottom",
      "visible-arrow": false,
      "auto-close": 2000
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_14, [(_openBlock(), _createElementBlock("svg", {
        viewBox: "0 0 34 34",
        onClick: _cache[3] || (_cache[3] = _withModifiers($event => $props.deleteHistoryHandler($props.groupInfo), ["prevent"]))
      }, _cache[11] || (_cache[11] = [_createElementVNode("use", {
        "xlink:href": "#delete"
      }, null, -1)])))])]),
      _: 1
    }, 8, ["content"]))]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.UtilityService.groupVersion($props.groupInfo.productVersion), (item, index) => {
      return _openBlock(), _createElementBlock("span", {
        class: "product-version",
        key: index
      }, [_createTextVNode(_toDisplayString(item.productFamily + " " + item.versions.join('/')) + " ", 1), index != $setup.UtilityService.groupVersion($props.groupInfo.productVersion).length - 1 ? (_openBlock(), _createElementBlock("span", _hoisted_17, ",")) : _createCommentVNode("", true)]);
    }), 128))]), $props.isShowVersionHeight && $props.groupInfo.productVersion && $props.groupInfo.productVersion.length == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_18, " no version ")) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", {
      class: "group-title rl-fontweight-medium",
      onMouseenter: _cache[4] || (_cache[4] = (...args) => $setup.showOutline && $setup.showOutline(...args)),
      onMouseleave: _cache[5] || (_cache[5] = (...args) => $setup.hideOutline && $setup.hideOutline(...args))
    }, [$props.groupInfo.label ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "label",
      style: _normalizeStyle({
        backgroundColor: $props.groupInfo.label.color
      })
    }, _toDisplayString($props.groupInfo.label.name), 5)) : $props.groupInfo.isNew ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.$t("COMMON.NEW")), 1)) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString($props.groupInfo.title), 1)], 32), _createElementVNode("div", _hoisted_21, [!$props.isShowDeleteHistoryButton ? (_openBlock(), _createElementBlock("svg", {
      key: 0,
      viewBox: "5 0 22 32",
      class: _normalizeClass(["bookmark", {
        active: $setup.state.isBookmarked
      }]),
      style: {
        "flex-shrink": "0",
        "align-self": "flex-start",
        "margin-left": "2px"
      },
      onClick: _cache[6] || (_cache[6] = _withModifiers($event => $props.clickBookmarkHandler(!$setup.state.isBookmarked, $props.groupInfo), ["prevent"]))
    }, [!$setup.state.isBookmarked ? (_openBlock(), _createElementBlock("use", _hoisted_22)) : _createCommentVNode("", true), $setup.state.isBookmarked ? (_openBlock(), _createElementBlock("use", _hoisted_23)) : _createCommentVNode("", true)], 2)) : (_openBlock(), _createBlock(_component_el_tooltip, {
      key: 1,
      content: _ctx.$t('HISTORY.REMOVE_FROM_WATCH_HISTORY'),
      placement: "bottom",
      "visible-arrow": false,
      "auto-close": 2000
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_24, [(_openBlock(), _createElementBlock("svg", {
        viewBox: "0 0 34 34",
        onClick: _cache[7] || (_cache[7] = _withModifiers($event => $props.deleteHistoryHandler($props.groupInfo), ["prevent"]))
      }, _cache[12] || (_cache[12] = [_createElementVNode("use", {
        "xlink:href": "#delete"
      }, null, -1)])))])]),
      _: 1
    }, 8, ["content"]))])]), _createElementVNode("div", _hoisted_25, [_createElementVNode("span", {
      innerHTML: $setup.state.description
    }, null, 8, _hoisted_26)]), $props.groupInfo.medias && $props.groupInfo.medias.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString($props.groupInfo.medias.length) + " Videos", 1)) : _createCommentVNode("", true), $setup.state.speakerNames.length ? (_openBlock(), _createElementBlock("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [$setup.state.videoType == $setup.videoType.webinar.type && $props.groupInfo.date ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString($props.groupInfo.date.replace(/\//g, "-")), 1)) : _createCommentVNode("", true), _createElementVNode("div", {
      class: "author-name",
      title: $setup.state.speakerNames,
      style: {
        "margin-left": "auto"
      }
    }, _toDisplayString($setup.state.speakerNames), 9, _hoisted_31)])])) : _createCommentVNode("", true), !$setup.state.speakerNames.length ? (_openBlock(), _createElementBlock("div", _hoisted_32)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.UtilityService.groupVersion($props.groupInfo.productVersion), (item, index) => {
      return _openBlock(), _createElementBlock("span", {
        class: "product-version",
        key: index
      }, [_createTextVNode(_toDisplayString(item.productFamily + " " + item.versions.join('/')) + " ", 1), index != $setup.UtilityService.groupVersion($props.groupInfo.productVersion).length - 1 ? (_openBlock(), _createElementBlock("span", _hoisted_35, ",")) : _createCommentVNode("", true)]);
    }), 128))]), _createElementVNode("div", _hoisted_36, [_createTextVNode(_toDisplayString($setup.state.category) + " ", 1), _cache[13] || (_cache[13] = _createElementVNode("span", {
      style: {
        "padding": "0 calc(0.6vw + 3px)"
      }
    }, "|", -1)), _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.$t("COMMON.LEVEL")), 1), _createElementVNode("span", _hoisted_38, [_createElementVNode("span", {
      class: _normalizeClass(["level-indicator", [$props.groupInfo.level >= 1 ? 'active' : '']])
    }, null, 2), _createElementVNode("span", {
      class: _normalizeClass(["level-indicator", [$props.groupInfo.level >= 2 ? 'active' : '']])
    }, null, 2), _createElementVNode("span", {
      class: _normalizeClass(["level-indicator", [$props.groupInfo.level === 3 ? 'active' : '']])
    }, null, 2)])]), $props.groupInfo.isSkeleton ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString($setup.state.category), 1)) : _createCommentVNode("", true)])])])], 2)), [[_directive_intersectionObserver, function () {
      return $props.impressionHandler($props.groupInfo, $props.position);
    }]])]),
    _: 1
  }, 8, ["to"])])) : _createCommentVNode("", true), $props.groupInfo.isSkeleton && $props.viewMode === $setup.state.viewModeType.ICON ? (_openBlock(), _createElementBlock("div", _hoisted_40, [_createVNode(_component_el_skeleton, {
    animated: ""
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_41, [_createElementVNode("img", {
      src: require('@/assets/images/skeletonImg.png'),
      alt: ""
    }, null, 8, _hoisted_42), _createVNode(_component_el_skeleton_item, {
      variant: "image",
      class: "el-skeleton-img-position"
    })]), _createElementVNode("div", _hoisted_43, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "100%"
      }
    }), _createElementVNode("div", _hoisted_44, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "30%"
      }
    })]), _createElementVNode("div", _hoisted_45, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "100%"
      }
    })])])]),
    _: 1
  })])) : _createCommentVNode("", true), $props.groupInfo.isSkeleton && $props.viewMode === $setup.state.viewModeType.DETAILS ? (_openBlock(), _createElementBlock("div", _hoisted_46, [_createVNode(_component_el_skeleton, {
    animated: ""
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_47, [_createElementVNode("div", _hoisted_48, [_createElementVNode("img", {
      src: require('@/assets/images/skeletonImg.png'),
      alt: ""
    }, null, 8, _hoisted_49), _createVNode(_component_el_skeleton_item, {
      variant: "image",
      class: "el-skeleton-img-position"
    })]), _createElementVNode("div", _hoisted_50, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "100%"
      }
    }), _createElementVNode("div", _hoisted_51, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "40%"
      }
    })]), _createElementVNode("div", _hoisted_52, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "100%"
      }
    })])])])]),
    _: 1
  })])) : _createCommentVNode("", true)], 64);
}